import { memo } from "react";

interface TagProps {
    text: string;
    onPress: () => void;
    isSelected: boolean;
}

const Tag = memo(({ text, onPress, isSelected }: TagProps) => {
    const selected = isSelected === false ? "check_link w-inline-block signup" : ' check_link w-inline-block signup_check';
    return (<>

        <a href="#" onClick={onPress} className={selected}>
            <div>{text}</div>
        </a>
    </>)
})

export default Tag;